<ng-template #rowActions let-employee>
  <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit(employee)" [actionData]="employee"></action-menu>
  <!-- <button
    mat-icon-button
    type="button"
    (click)="manageDependants.emit(employee)"
    aria-label="Manage dependants"
    matTooltip="Manage dependants"
  >
    <mat-icon>groups</mat-icon>
  </button>
  <a
    mat-icon-button
    [routerLink]="['/employees', employee.id]"
    [queryParams]="{ clientId: employee.clientId }"
    aria-label="Detail"
    matTooltip="Detail"
  >
    <mat-icon>visibility</mat-icon>
  </a>
  @if ((employee.isActive && canDeactivate()) || (!employee.isActive && canActivate())) {
    <button
      mat-icon-button
      type="button"
      [disabled]="actionEmployeeId() === employee.id"
      (click)="toggled.emit(employee)"
      [attr.aria-label]="employee.isActive ? 'Deactivate' : 'Activate'"
      [matTooltip]="employee.isActive ? 'Deactivate' : 'Activate'"
    >
      @if (actionEmployeeId() === employee.id) {
        <mat-spinner diameter="18" />
      } @else {
        <mat-icon>{{ employee.isActive ? 'block' : 'check_circle' }}</mat-icon>
      }
    </button>
  } -->
</ng-template>

<data-table
  title="Employees"
  searchLabel="Search employees"
  searchPlaceholder="Name, employee #, or email"
  loadingMessage="Loading employees..."
  emptyMessage="No employees found."
  [rows]="employees()"
  [columns]="columns"
  [actionsTemplate]="rowActions"
  [loading]="loading()"
  [showRefresh]="true"
  [searchEnabled]="true"
  [searchTerm]="searchTerm()"
  [paginationEnabled]="true"
  [pageNumber]="pageNumber()"
  [pageSize]="pageSize()"
  [totalCount]="totalCount()"
  [totalPages]="totalPages()"
  (refreshed)="refreshed.emit()"
  (searchChanged)="searchChanged.emit($event)"
  (pageChanged)="pageChanged.emit($event)" />
